import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building, LogOut } from 'lucide-react';
import { useAuth } from './AuthContext';
import Tabs from './components/Tabs';
import UserManagementTable from './components/UserManagementTable';
import ResourceManagementTable from './components/ResourceManagementTable';

const AdminPanel = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'users', label: 'User Management' },
    { id: 'resources', label: 'Resource Management' },
  ];

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Building className="w-8 h-8 text-purple-600" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={handleGoToDashboard}
                className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                title="Dashboard"
              >
                <Building className="w-4 h-4" />
                <span>Dashboard</span>
              </button>

              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {/* Tabs */}
          <div className="px-6 pt-6">
            <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === 'users' && <UserManagementTable />}
            {activeTab === 'resources' && <ResourceManagementTable />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
